/**
 * Helpers de fecha/hora en zona Argentina (-03:00, sin DST hace anios).
 * Trabajamos en UTC en la API y convertimos al renderizar.
 */

const TZ = 'America/Argentina/Buenos_Aires';

/** Devuelve YYYY-MM-DD en zona del salon. */
export function toISODate(d: Date): string {
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
  return fmt.format(d);
}

/** "13:30" en zona del salon. */
export function toLocalTime(isoUtc: string): string {
  const d = new Date(isoUtc);
  return d.toLocaleTimeString('es-AR', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false });
}

/** "lun 5 may" en zona del salon. */
export function toLocalDay(d: Date): string {
  return d.toLocaleDateString('es-AR', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' });
}

/** "Lunes 5 de mayo" en zona del salon. */
export function toLocalDayLong(d: Date): string {
  const s = d.toLocaleDateString('es-AR', { timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long' });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Devuelve el ISO UTC para inicio del dia local (00:00 hora salon). */
export function startOfDayUTC(localDate: string): string {
  // Truco: formateamos un Date a las 00:00 y -3hs lo deja en 03:00 UTC.
  // localDate es YYYY-MM-DD asumido en zona del salon.
  const [y, m, d] = localDate.split('-').map(Number);
  // 00:00 ART = 03:00 UTC
  const dt = new Date(Date.UTC(y!, m! - 1, d!, 3, 0, 0, 0));
  return dt.toISOString();
}

export function endOfDayUTC(localDate: string): string {
  const [y, m, d] = localDate.split('-').map(Number);
  // 23:59:59.999 ART = 02:59:59.999 UTC del dia siguiente.
  const dt = new Date(Date.UTC(y!, m! - 1, d! + 1, 2, 59, 59, 999));
  return dt.toISOString();
}

/** Suma N dias (en UTC milliseconds — preciso para zona fija). */
export function addDays(localDate: string, n: number): string {
  const [y, m, d] = localDate.split('-').map(Number);
  const dt = new Date(Date.UTC(y!, m! - 1, d! + n));
  return toISODate(dt);
}

/** Combina fecha local YYYY-MM-DD y hora local HH:MM en ISO UTC. */
export function combineLocal(localDate: string, localTime: string): string {
  const [y, m, d] = localDate.split('-').map(Number);
  const [h, min] = localTime.split(':').map(Number);
  // ART = UTC -3, asi que sumamos 3h para llevar a UTC.
  const dt = new Date(Date.UTC(y!, m! - 1, d!, (h ?? 0) + 3, min ?? 0, 0, 0));
  return dt.toISOString();
}

/** Hoy en zona del salon, formato YYYY-MM-DD. */
export function todayLocal(): string {
  return toISODate(new Date());
}

/** Genera lista de slots de tiempo cada N min entre open y close ("HH:MM"). */
export function generateTimeSlots(openTime: string, closeTime: string, stepMin: number): string[] {
  const slots: string[] = [];
  const [oh, om] = openTime.split(':').map(Number);
  const [ch, cm] = closeTime.split(':').map(Number);
  const open = (oh ?? 0) * 60 + (om ?? 0);
  const close = (ch ?? 0) * 60 + (cm ?? 0);
  for (let m = open; m < close; m += stepMin) {
    const h = Math.floor(m / 60);
    const mi = m % 60;
    slots.push(`${String(h).padStart(2, '0')}:${String(mi).padStart(2, '0')}`);
  }
  return slots;
}
